import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NavItem, NavLink } from 'reactstrap';
import { MyMLabel } from '../ui-elements/MyMLabel';

export const MenuNavItem = (props) => {

  const { fontSize, linkTo, label, onClickAction, needsOpenTab } = props;

  const StyledLink = styled(Link)(() => ({
    '&:hover': {
      textDecoration: 'underline solid white',
    }
  }));

  const navLinkProps = {
    tag     : StyledLink,
    onClick : onClickAction,
    target: needsOpenTab ? "_blank" : "_self",
  }

  if (onClickAction) {
    navLinkProps.href = linkTo;
  } else {
    navLinkProps.to = linkTo;
  }

  return (
    <NavItem>
      <NavLink {...navLinkProps}>
        <MyMLabel fontSize={fontSize}>{label}</MyMLabel>
      </NavLink>
    </NavItem>
  );
};

// 2024.9.16 MyMine Version2.0対応 Add Start
export const HamburgerMenuItem = ({
  handleClose,
  menu,
  menuText,
  // 2025.7.7 MyMine Version3.0対応 Add Start
  screenId
  // 2025.7.7 MyMine Version3.0対応 Add End
}) => {
  const navigate = useNavigate();
  return (
    <ListItem
      sx={{
        height: 65,
        borderBottom: '1px solid #8080806e',
        ':hover': {
          cursor: 'pointer',
          textDecoration: 'underline',
          backgroundColor: '#DDDDDD',
        },
      }}
      onClick={() => {
        handleClose();
        menu.onClickAction && menu.onClickAction();

        if (menu.linkTo !== '#') {

          // 2025.7.7 MyMine Version3.0対応 Add Start
          // 画面IDがパラメータに指定されている 且つ 遷移先がMyMine内の場合、
          // アクセスログ記録用にリンクにrefパラメータとして画面IDを追加する
          if (screenId && /MyM\d{3}$/.test(menu.linkTo)) {
            menu.linkTo += '?ref=MyM901'
          }
          // 2025.7.7 MyMine Version3.0対応 Add End

          if (menu.needsOpenTab) {
            window.open(menu.linkTo, '_blank');
          } else {
            navigate(menu.linkTo);
          }
        }

      }}>
      <MyMLabel>{menuText}</MyMLabel>
    </ListItem>
  );
}
// 2024.9.16 MyMine Version2.0対応 Add End